// Public IP inventory and monitoring API. Uses Nightjar's existing authenticated client.
import api from "./api";

export const PublicIpsAPI = {
  list: (schoolId) => api(`/public-ips${schoolId ? `?school_id=${encodeURIComponent(schoolId)}` : ""}`),
  get: (id) => api(`/public-ips/${encodeURIComponent(id)}`),
  forSchool: (schoolId) => api(`/public-ips/school/${encodeURIComponent(schoolId)}`),
  create: (data) => api("/public-ips", { method: "POST", body: JSON.stringify(data) }),
  update: (id, data) => api(`/public-ips/${encodeURIComponent(id)}`, { method: "PUT", body: JSON.stringify(data) }),
  remove: (id) => api(`/public-ips/${encodeURIComponent(id)}`, { method: "DELETE" }),
  overview: () => api("/public-ips/monitoring/overview"),
  monitoring: (id, days = 1) => api(`/public-ips/${encodeURIComponent(id)}/monitoring?days=${encodeURIComponent(days)}`),
};
